import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { ResponsibleGamblingComponent } from './pages/responsible-gambling/responsible-gambling.component';
import { FaqComponent } from './pages/faq/faq.component';
import { TestimonialsPageComponent } from './pages/testimonials/testimonials.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { HeroComponent } from './components/hero/hero.component';
import { BrandListComponent } from './components/brand-list/brand-list.component';
import { LargeContentComponent } from './components/large-content/large-content.component';
import { FaqSectionComponent } from './components/faq-section/faq-section.component';
import { ResponsibleGamblingSectionComponent } from './components/responsible-gambling-section/responsible-gambling-section.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { PromotionsComponent } from './components/promotions/promotions.component';
import { RegulatorySignsComponent } from './components/regulatory-signs/regulatory-signs.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'responsible-gambling', component: ResponsibleGamblingComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'testimonials', component: TestimonialsPageComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    TermsComponent,
    PrivacyComponent,
    ResponsibleGamblingComponent,
    FaqComponent,
    TestimonialsPageComponent,
    AppHeaderComponent,
    AppFooterComponent,
    HeroComponent,
    BrandListComponent,
    LargeContentComponent,
    FaqSectionComponent,
    ResponsibleGamblingSectionComponent,
    TestimonialsComponent,
    PromotionsComponent,
    RegulatorySignsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'kansinonederland' }),
    HttpClientModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledBlocking'
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

